import {
  reactQueryGet,
  reactQueryPost,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

const update = (planId: number, planCouponId?: number, source?: string) =>
  reactQueryPut(
    internalApi.AccountSubscriptions.update(planId, planCouponId, source),
  );

const renew = (planId: number) =>
  reactQueryPost(internalApi.AccountSubscriptions.renew(planId));

const canDowngrade = (planId: number) =>
  reactQueryGet(internalApi.AccountSubscriptions.canDowngrade(planId));

const createEmailHubSubscription = () =>
  reactQueryPost(internalApi.AccountSubscriptions.createEmailHubSubscription());

const reactivateEmailHubSubscription = () =>
  reactQueryPost(
    internalApi.AccountSubscriptions.reactivateEmailHubSubscription(),
  );

export const accountSubscriptionApi = {
  update,
  renew,
  canDowngrade,
  createEmailHubSubscription,
  reactivateEmailHubSubscription,
};
